// Imports of the module

import { parseDateWithHoursUTC } from "@/lib/utils";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import { assetClassOptions, instrumentOptions, statusOptions } from "./filter";

// Helper functions to convert enum values to labels
const getEnumLabel = (
  value: any,
  options: { value: string; label: string }[],
): string => {
  if (value === null || value === undefined) return "";
  const option = options.find((opt) => opt.value === String(value));
  return option ? option.label : String(value);
};

// Type of the fields in the table

export type Strategy = {
  id: number;
  type: string | null;
  ticker: string | null;
  isin: string | null;
  currency: number | null;
  currency_text: string | null; // From LEFT JOIN with enum_strategy_currencies
  name: string;
  company_id?: number | null;
  company: string | null; // From LEFT JOIN with companies table
  status: number | null;
  asset_class: number | null;
  instrument: number | null;
  fund_name: string | null;
  created_at: string;
};

// Definition of the columns

export const strategies_columns: ColumnDef<Strategy>[] = [
  {
    accessorKey: "id",
    header: "ID",
  },
  {
    accessorKey: "type",
    header: "Type",
    cell: ({ row }) => row.getValue("type") || "",
  },
  {
    accessorKey: "ticker",
    header: "Ticker",
    cell: ({ row }) => row.getValue("ticker") || "",
  },
  {
    accessorKey: "isin",
    header: "ISIN",
    cell: ({ row }) => row.getValue("isin") || "",
  },
  {
    accessorKey: "currency_text",
    header: "Currency",
    cell: ({ row }) => row.getValue("currency_text") || "",
  },
  {
    accessorKey: "name",
    header: "Name",
    cell: ({ row }) => row.getValue("name"),
  },
  {
    accessorKey: "company",
    header: "Company",
    cell: ({ row }) => row.getValue("company") || "",
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => getEnumLabel(row.getValue("status"), statusOptions),
  },

  {
    accessorKey: "asset_class",
    header: "Asset Class",
    cell: ({ row }) =>
      getEnumLabel(row.getValue("asset_class"), assetClassOptions),
  },
  {
    accessorKey: "instrument",
    header: "Instrument",
    cell: ({ row }) =>
      getEnumLabel(row.getValue("instrument"), instrumentOptions),
  },
  {
    accessorKey: "fund_name",
    header: "Fund Name",
    cell: ({ row }) => row.getValue("fund_name") || "",
  },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => parseDateWithHoursUTC(row.getValue("created_at")),
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => {
      const strategyId = row.getValue("id");
      return (
        <div className="flex justify-end gap-2">
          <Link
            href={`${window.location.pathname}/${strategyId}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
